"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalBase = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactModal = _interopRequireDefault(require("react-modal"));
var _classnames = _interopRequireDefault(require("classnames"));
var _modalBaseModule = _interopRequireDefault(require("./modal-base.module.scss"));
var _useAfterCloseCallback = require("./hooks/useAfterCloseCallback");
var _noop = require("../../utils/noop");
_reactModal.default.setAppElement('body');
var CLOSE_TIMEOUT_MS = 200;

// https://github.com/reactjs/react-modal/issues/960
var React18Modal = _reactModal.default;
var ModalBase = function ModalBase(_ref) {
  var isOpen = _ref.isOpen,
    className = _ref.className,
    close = _ref.close,
    children = _ref.children,
    afterClose = _ref.afterClose,
    _ref$closable = _ref.closable,
    closable = _ref$closable === void 0 ? true : _ref$closable;
  (0, _useAfterCloseCallback.useAfterCloseCallback)(isOpen, afterClose, CLOSE_TIMEOUT_MS);
  return /*#__PURE__*/_react.default.createElement(React18Modal, {
    isOpen: isOpen,
    bodyOpenClassName: _modalBaseModule.default['modal-base--open'],
    shouldCloseOnEsc: closable,
    shouldCloseOnOverlayClick: closable,
    testId: "modal",
    closeTimeoutMS: CLOSE_TIMEOUT_MS,
    onRequestClose: closable ? close : _noop.noop,
    className: (0, _classnames.default)(_modalBaseModule.default['modal-base'], className),
    overlayClassName: _modalBaseModule.default['modal-base__overlay'],
    contentElement: function contentElement(props, children) {
      return /*#__PURE__*/_react.default.createElement("div", Object.assign({}, props, {
        onClick: function onClick(e) {
          e.stopPropagation();
        }
      }), children);
    }
  }, children);
};
exports.ModalBase = ModalBase;